import { render } from "./OperationsWindow.vue?vue&type=template&id=c508a8d0"
import script from "./OperationsWindow.vue?vue&type=script&lang=js"
export * from "./OperationsWindow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__